import { IDriveInfo } from "../../interfaces/IDriveInfo";
import { AttachmentService } from "../../services/AttachmentService";
import { InlineMailHelper } from "../../services/InlineMailHelper";

export class InlineEmailHelperWrapper {
    static addEmailWithAttachments = async (driveInfos: IDriveInfo[], unableToAttachTryAgain: string) => {
        const attachments = await AttachmentService.getAttachmentLinks(driveInfos)
        InlineMailHelper.setAttachments(attachments, unableToAttachTryAgain);
    };

    static addShareableLinks = async (driveInfos: IDriveInfo[], UnableToAppendLinkTryAgain: string, isOrganization: boolean) => {
        const shareableLinks = await AttachmentService.getShareableLinks(driveInfos, isOrganization);
        InlineMailHelper.setItemLinks(shareableLinks, UnableToAppendLinkTryAgain);
    }
}